// lib/whatsapp.ts
// Shared WhatsApp destinations. The lab group invite is the social-proof
// channel for practical/experiment hubs: questions asked there are visible to
// other practical prospects, which signals demand and builds confidence in the
// lab setup. Whether practical hubs route their CTAs to the group or to the
// 1-to-1 business line is controlled by FORCE_PRACTICAL_GROUP_CTA below.

/** WhatsApp group invite for practical / experiment lab enquiries. */
export const LAB_GROUP_CHAT_URL =
  "https://chat.whatsapp.com/IfHWgqQZnX40sB40MESnSM" as const;

/** 1-to-1 WhatsApp business line (default lead CTA on non-practical pages). */
export const ONE_TO_ONE_WHATSAPP_PHONE = "6590065997" as const;

/**
 * Pre-filled message for the 1-to-1 line on practical/experiment hubs. The
 * generic WhatsAppButton default mentions IP tuition, which is wrong on a
 * practical page, so practical 1-to-1 CTAs pass this instead.
 */
export const PRACTICAL_ONE_TO_ONE_MESSAGE =
  "Hi Eclat Institute, I'd like to ask about your practical / lab sessions." as const;

/** Compact label for WhatsApp actions in the global site header. */
export const HEADER_WHATSAPP_CTA_LABEL = "WhatsApp Us" as const;

/** Offer-led label for WhatsApp CTAs inside practical-page content. */
export const PRACTICAL_WHATSAPP_CTA_LABEL =
  "Text us for guided lab sessions" as const;

/**
 * Master switch for the CTA channel on practical/experiment hubs.
 *
 * When true, all three practical-hub CTAs (sticky header button, hero button,
 * and the in-content enquiry block) route to the lab group instead of the
 * 1-to-1 business line — making those hubs group-only.
 *
 * Held OFF (client decision, 2026-06-13): while lead volume is still low the
 * client prefers to keep the low-friction 1-to-1 escape hatch — maximise
 * relevant leads (recall) over suppressing off-topic enquiries (precision) —
 * and switch practical hubs to group-only once volume builds. The group's
 * social-proof / demand-signal value only pays off at volume. The group
 * mechanism (dual header button + globals.css :has() rules + the page marker,
 * plus the hero/in-content group copy) is kept wired so re-enabling is a
 * one-line flip to `true`. The lab-certificate preview is independent of this
 * flag and shows regardless. "When we got volume then we change to group."
 * See reports/practical-whatsapp-group-cta-baseline-2026-06-13.md.
 */
export const FORCE_PRACTICAL_GROUP_CTA = false;

/** Default programme enquiry shared by the button and locale-aware header. */
export const DEFAULT_WHATSAPP_ENQUIRY_MESSAGE =
  "Hi Eclat Institute, please help me choose the right tuition or practical programme. The student's school and level are <school / level>, the subject is <subject>, and we need <theory / practical / both>.";
